import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { toast } from 'react-toastify';
import SelectUserDashboardForm from './form/SelectUserDashboardForm';
import { withHOCSRouter } from '../components/hocs';
import { copyDashboard, getDashboard } from '../api/dashboard';
import { dashboardCreated } from '../actions/dashboard';

const messages = defineMessages({
  SUCCESS: {
    id: 'DashboardContainerPage.SUCCESS_DASHBOARD_COPIED',
    defaultMessage: 'Dashboard copied successfully',
  },
  ERROR: {
    id: 'DashboardContainerPage.ERROR_USER_REGISTRATION_CODE',
    defaultMessage: 'An error has occurred. Please try again',
  },
});

const SelectUserDashboardComponent = (props) => <SelectUserDashboardForm {...props} />;

export default injectIntl(
  connect(
    (state) => ({
      is_select_dashboard: true,
      user: state.auth.user,
    }),
    (dispatch, { intl: { formatMessage } }) => ({
      copyDashboard: async ({ user_id, copy_dashboard_id }) => {
        if (user_id && copy_dashboard_id) {
          try {
            const createdDashboard = await copyDashboard(copy_dashboard_id, user_id);
            if (createdDashboard && createdDashboard.status === 201) {
              toast.success(formatMessage(messages.SUCCESS));

              dispatch(dashboardCreated({ data: createdDashboard.body }));

              return true;
            }
            toast.warn(formatMessage(messages.ERROR));
          } catch (error) {
            toast.warn(formatMessage(messages.ERROR));
          }
        }

        return false;
      },
      loadDashboards: async (dashboard_ids, external_user_id, external_user_name, navigate) => {
        try {
          if (dashboard_ids && dashboard_ids.length > 0) {
            if (dashboard_ids.length === 1) {
              navigate(`/dashboard/${dashboard_ids[0]}/`, {
                state: {
                  external_user_id: external_user_id,
                  external_user_name: external_user_name,
                },
              });
            } else {
              // eslint-disable-next-line consistent-return
              const promises = dashboard_ids.slice(1).map(async (dashboard_id) => {
                const dashboard = await getDashboard(dashboard_id);
                if (dashboard) {
                  if (
                    external_user_id &&
                    external_user_name &&
                    !dashboard.external_user_id &&
                    !dashboard.external_user_name
                  ) {
                    dashboard.external_user_id = external_user_id;
                    dashboard.external_user_name = external_user_name;
                  }
                  return dispatch(dashboardCreated({ data: dashboard }));
                }
                return null;
              });
              // Wait for all dashboard actions to complete
              await Promise.all(promises);

              navigate(`/dashboard/${dashboard_ids[0]}/`, {
                state: {
                  external_user_id: external_user_id,
                  external_user_name: external_user_name,
                },
              });
            }
          }
        } catch (error) {
          toast.warn(formatMessage(messages.ERROR));
        }
      },
    })
  )(withHOCSRouter(SelectUserDashboardComponent))
);
